import React from 'react';
import { Modal } from '../../organisms/Modal';
import { Button } from '../../atoms/Button';
import './ConfirmationDialog.css';

export interface ConfirmationDialogProps {
  /** Whether the dialog is open */
  isOpen: boolean;
  /** Dialog title */
  title: string;
  /** Confirmation message or content */
  children: React.ReactNode;
  /** Label for the confirm button */
  confirmLabel?: string;
  /** Label for the cancel button */
  cancelLabel?: string;
  /** Button variant for the confirm button */
  confirmVariant?: 'primary' | 'warning' | 'success';
  /** Called when the user confirms */
  onConfirm: () => void;
  /** Called when the user cancels (or closes the dialog) */
  onCancel: () => void;
  /** Whether the confirm button is in a loading state */
  loading?: boolean;
  /** Optional additional CSS classes */
  className?: string;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  isOpen,
  title,
  children,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmVariant = 'primary',
  onConfirm,
  onCancel,
  loading = false,
  className = '',
}) => {
  const classes = ['hi-ui-confirmation-dialog', className].filter(Boolean).join(' ');

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title={title}
      size="small"
      className={classes}
      footer={
        <>
          <Button variant={confirmVariant} onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </Button>
          <Button variant="tertiary" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </Button>
        </>
      }
    >
      {children}
    </Modal>
  );
};
